import api from './api';
import type { BilltoOpt, CustomerOpt, LocationOpt } from './contstatusreport.service';

/**
 * Melrose Template Mapping — option bundle for the drawer. Customer / Bill To are the
 * shared enriched FK lists; locations power the Consignee + Pickup typeaheads; scacs is
 * the shared SS-line SCAC list. (Move Type / Equip Type come from frontend constants and
 * the Template lookup reuses /daltile/template-search.)
 */
export interface MelroseScacOpt { scac: string; name: string; }

export interface MelroseOptions {
  customers: CustomerOpt[];
  billtos: BilltoOpt[];
  locations: LocationOpt[];
  scacs: MelroseScacOpt[];
}

export async function getMelroseOptions(): Promise<MelroseOptions> {
  const res = await api.get('/melrose/form-options');
  return res.data as MelroseOptions;
}
